import {
  SummaryCard,
  Tab,
  TabList,
  TabPanel,
  Tabs,
} from "@certn/cascadia-react";
import { slugify } from "@certn/utils";
import { LayoutProps, isCategorization } from "@jsonforms/core";
import { JsonFormsDispatch } from "@jsonforms/react";
import { useContext } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { withCascadiaLayoutProps } from "../wrappers/withCascadiaLayoutProps";

export function CategorizationLayout(props: LayoutProps) {
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);
  const { uischema, path } = props;
  const testID = `form-categorization-tabs-${slugify(props.label)}`;

  if (!isCategorization(uischema)) {
    return null;
  }

  if (isSummaryForPath?.(path)) {
    return (
      <>
        {uischema.elements.map((_category, index) => {
          const category = _category as typeof _category & { name: string };

          if (
            category.type === "Category" &&
            category.options?.include_summary
          ) {
            return (
              <SummaryCard
                key={`${slugify(category.label)}-${index}`}
                header={category.label}
                testID={`${testID}-${slugify(category.label)}-summary`}
              >
                <JsonFormsDispatch schema={props.schema} uischema={category} />
              </SummaryCard>
            );
          }

          return (
            <JsonFormsDispatch
              key={`${category.label}-${index}`}
              schema={props.schema}
              uischema={category}
            />
          );
        })}
      </>
    );
  }

  return (
    <Tabs testID={testID}>
      <TabList>
        {uischema.elements.map((category, index) => (
          <Tab
            id={String(index)}
            key={`${testID}-${slugify(category.label)}-tab`}
            testID={`${testID}-${slugify(category.label)}-tab`}
          >
            {category.label}
          </Tab>
        ))}
      </TabList>
      {uischema.elements.map((category, index) => (
        <TabPanel
          id={String(index)}
          key={`${testID}-${slugify(category.label)}-tabpanel`}
        >
          <JsonFormsDispatch schema={props.schema} uischema={category} />
        </TabPanel>
      ))}
    </Tabs>
  );
}

export const CategorizationLayoutRenderer =
  withCascadiaLayoutProps(CategorizationLayout);
